import { Component, Input, OnInit } from '@angular/core';

import { ApiError, BaseFormList, MessageService } from '../../../../core';

import { RepresentanteVinculado } from './representante-vinculado';
import { Representante } from '../representante';

@Component({
    selector: 'sgt-representante-vinculado',
    templateUrl: './representante-vinculado.component.html',
    styleUrls: ['./representante-vinculado.component.less']
})
export class RepresentanteVinculadoComponent implements BaseFormList<RepresentanteVinculado>, OnInit {
    @Input() entities: RepresentanteVinculado[];

    constructor(private messageService: MessageService) { }

    ngOnInit() {

    }

   /** Ao alterar o representante no typeahead */
   onChangeRepresentanteVinculado(entity: RepresentanteVinculado, representante: Representante) {
    if (representante) {
        entity.idRepresentanteVinculado = representante.id;
    } else {
        entity.idRepresentanteVinculado = null;
    }
}

    insert() {
        const entity = new RepresentanteVinculado();
        this.entities.push(entity);
    }

    delete(index: number) {
        const entity = this.entities[index];
        const nomeRepresentante = (entity && entity.representanteVinculado && entity.representanteVinculado.pessoa) ? entity.representanteVinculado.pessoa.nome : '';
        this.messageService.confirm(`Deseja realmente excluir vínculo do representante ${nomeRepresentante} com o representante?`).then(result => {
            if (result) {
                this.entities.splice(index, 1);
            }
        });
    }

    /** Verifica se os representantes vinculados ao representante estão válidos */
    isValid(): boolean {
        for (let i = 0; i < this.entities.length; i++) {
            const entity = this.entities[i];


            const count = this.entities.filter(entityFilter => entityFilter.idRepresentanteVinculado && entityFilter.idRepresentanteVinculado === entity.idRepresentanteVinculado).length;
            const nomeRepresentante = (entity && entity.representanteVinculado && entity.representanteVinculado.pessoa) ? entity.representanteVinculado.pessoa.nome : '';
            if (count > 1) {
                this.messageService.info(`O vínculo do representante ${nomeRepresentante} já está adicionado a este representante. Remova ou altere este vínculo duplicado`, 'Não é possível adicionar dois vínculos do mesmo representante');
                return false;
            }
        }

        return true;
    }

    /** Resolve os representantes vinculados ao representante */
    resolve() {
        for (let i = this.entities.length; i--; ) {
            const entity = this.entities[i];
            if (!entity.idRepresentanteVinculado) {
                this.entities.splice(i, 1);
            }
        }
    }
}
